var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-actions-menu',[_c('edit-button',{attrs:{"url":_vm.route('tenant.clients.wbt-configs.show', {
                    client: _vm.data.client_id,
                    wbt_config: _vm.data.id
                })}}),_vm._v(" "),_c('delete-button',{attrs:{"url":_vm.route('tenantapi.clients.wbt-configs.destroy', {
                    client: _vm.data.client_id,
                    wbt_config: _vm.data.id
                }),"confirmTitle":this.trans('wbt_configs.note.delete_title'),"confirmText":this.trans('wbt_configs.note.delete_message'),"deleteId":_vm.data.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }